import { ArticleText } from 'ui/components/2-molecules/Article';
import { useShouldShowContent } from 'helpers/audiencehelper';
export const ArticleTextFeature: React.FC<Umbraco.ArticleText> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);
	return show ? <ArticleText {...content?.properties} /> : <></>;
};
